import React, { useState, useEffect } from "react";
import Login from "./login"
import SignIn from "./signin"
import TabbarEvents from "../../globals/dhtmlx/Tabbar"
import "../../../dhtmlx/codebase/suite.css";
import styled from "styled-components";

const Container = styled.section`
  width: 100%;
  display: grid;
  justify-content: center;
  align-content: center;
  height: auto;
  padding: 56px 0 16px 0;
`;

const Welcome = styled.h1`
  display: flex;
  justify-content: center;
  font-size: 32px  
`;


function Inicio(props){

  const [showLogin, setShowLogin] = useState(true);

  function changeTabbToogle() {
    if(showLogin === true){
      setShowLogin(false);
    }
    else{
      setShowLogin(true);
    }    
  }
  useEffect(() => {
  }, [showLogin]);

  return (
    <Container>
      <Welcome>MarketPlace GP</Welcome>
      <TabbarEvents
        view = {[
          {
            id: "login",
            tab: "Iniciar Sesión"
              
          },
          {
            id: "signin",
            tab: "Registro"
          }
        ]}
        onChange = {changeTabbToogle}
      />
      <section>
        <Login
          show = {showLogin}
        />
        <SignIn
          show = {!showLogin}
        />
      </section>
    </Container>
  ); 
}

export default Inicio;
